import toast from 'react-hot-toast';

/**
 * Extrae un mensaje de error que puede ser:
 * - string: "Usuario o contraseña incorrectos"
 * - objeto: { message: "...", error_code: "..." }
 * - Error instance: Error con .message
 */
function extractErrorMessage(error: any): string {
  // Si es string directo
  if (typeof error === 'string') {
    // Caso: el string es un objeto serializado {"message": "...", "error_code": "..."}
    // o {'message': '...', 'error_code': '...'}
    if (error.includes('message')) {
      try {
        // Intentar parsear como JSON (convertir comillas simples a dobles primero)
        const jsonStr = error.replace(/'/g, '"');
        const parsed = JSON.parse(jsonStr);
        if (parsed.message) {
          return String(parsed.message);
        }
      } catch {
        // No es JSON válido, continuar
      }
    }
    // Si es un string normal, devolverlo
    return error;
  }

  // Si es Error instance (debe checkearse ANTES que objeto genérico)
  if (error instanceof Error) {
    return error.message;
  }

  // Si es objeto con propiedad message
  if (error && typeof error === 'object') {
    // Caso: { message: "...", error_code: "..." }
    if (typeof error.message === 'string') {
      return error.message;
    }
    // Caso: { detail: "..." }
    if (typeof error.detail === 'string') {
      return error.detail;
    }
  }

  // Fallback
  return 'Ocurrió un error';
}

/**
 * Wrapper de toast.error que maneja correctamente mensajes de error
 */
export const toastError = (error: any, options?: any) => {
  const message = extractErrorMessage(error);
  return toast.error(message, options);
};

/**
 * Wrapper de toast.success
 */
export const toastSuccess = (message: string, options?: any) => {
  return toast.success(message, options);
};

/**
 * Wrapper de toast.loading
 */
export const toastLoading = (message: string, options?: any) => {
  return toast.loading(message, options);
};

/**
 * Wrapper de toast.dismiss
 */
export const toastDismiss = (toastId?: string) => {
  return toast.dismiss(toastId);
};

/**
 * Wrapper de toast para mensajes informativos
 */
export const toastInfo = (message: string, options?: any) => {
  return toast(message, options);
};

export default {
  error: toastError,
  success: toastSuccess,
  loading: toastLoading,
  dismiss: toastDismiss,
  info: toastInfo,
};
